import clsx, { ClassValue } from 'clsx'

// eslint-disable-next-line import/prefer-default-export
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs)
}
